<script setup lang="ts">
  import { useUserStore } from '@/stores/user'
  import { useProjectBackupStore } from '@/stores/project-backups'
  import fetchInterceptor from '@/interceptors/fetch'
  import { IntercomDes } from '@/helpers/intercomDes'
  import { MixpanelDes } from '@/helpers/mixpanelDes'
  import BugSnagDes from '@/helpers/bugSnagDes'
  import Hotjar from '@hotjar/browser'

  // Install fetch interceptor BEFORE making any API calls
  fetchInterceptor(window)

  const user = useUserStore()
  if (user.user && !user.isClientAccount()) {
    user.getExtraSettings()
    user.getPublicConfig()
    user.getDescription()
    user.checkStripeAccountStatus()
    user.refreshAccountType()
  }

  const backups = useProjectBackupStore()
  backups.openIndexedDb()

  IntercomDes.setupIntercom(IntercomDes.skipIntercom)
  MixpanelDes.setupMixpanel(IntercomDes.skipIntercom)
  BugSnagDes.instance.setBugSnag(user.user)

  //use Hotjar only on APP, and only on browsers that support :has() (required by Hotjar internally)
  if (window.location.hostname === 'app.designrr.io' && import.meta.env.VITE_HOTJAR_SITE_ID) {
    try {
      if (CSS.supports('selector(:has(div))')) {
        Hotjar.init(import.meta.env.VITE_HOTJAR_SITE_ID, 6)
      }
    } catch {
      // CSS.supports not available in this browser - skip Hotjar
    }
  }
</script>

<template>
  <RouterView :key="$route.fullPath" />
</template>
